import 'containers/OldNewWordsFrame/index.scss';
import SvgObject from 'containers/OldNewWordsFrame/SvgObject';
import React, {FC, useCallback} from 'react';
import {flatBem} from 'utils/bem';
import {Configurator} from 'utils/makeConfigurator';

const b = flatBem('OldNewWordsFrame');

type Props = {
  data: {svg: string};
  conf: Configurator;
};

const Component: FC<Props> = ({data, conf}) => {
  const svgParentRef = useCallback(
    node => {
      if (node === null) return;
      new SvgObject(data.svg, node, conf('isMobile', false)).activate();
    },
    [data.svg, conf],
  );
  return (
    <div className={b()}>
      <div className={b('svg-parent')} ref={svgParentRef} />
    </div>
  );
};

export default Component;
